<template>
	<div class="main">
		<Table
			:columns="columns"
			row-key="id"
			:request="request"
			:searchData ="searchData"
			:formData="formData"
			:mulselect="false"
			:rowClassName="changecolor"
			ref="tableref"
		>
		<!-- 查询form -->
		<template v-slot:formItem>
			<a-form-model-item>
				<a-input v-model="searchData.name" style="width:90px" allowClear placeholder="姓名" />
			</a-form-model-item>
			<a-form-model-item>
				<a-input v-model="searchData.idcard" style="width:150px" allowClear placeholder="身份证号" />
			</a-form-model-item>
			<a-form-model-item>
				<a-input v-model="searchData.banknum" allowClear style="width:200px" placeholder="银行卡号" />
			</a-form-model-item>
			<a-form-model-item>
				<a-input v-model="searchData.group" allowClear placeholder="所属班组" style="width:120px" />
			</a-form-model-item>
			<a-form-model-item>
				<a-select v-model="searchData.workplace" allowClear placeholder="所属工地" style="width:180px">
					<a-select-option v-for="item in workplaceArray" :key="item.id" :value="item.id" >{{item.name}}</a-select-option>
				</a-select>
			</a-form-model-item>
           <a-form-model-item >
               <a-date-picker style="width:120px" v-model="searchData.starttime" allowClear  placeholder="开始时间"/>
           </a-form-model-item> 
           <a-form-model-item >
               <a-date-picker style="width:120px" v-model="searchData.endtime" allowClear  placeholder="结束时间"/>
           </a-form-model-item> 
		</template>

		<!-- 保存数据的form -->
		<template v-slot:itemFormData>
			<div style="width:700px">
			<a-form-model-item label="开始时间">
                <a-date-picker placeholder="请输入开始时间" v-model="formData.starttime"></a-date-picker>
            </a-form-model-item>
			<a-form-model-item label="结束时间">
                <a-date-picker placeholder="请输入结束时间" v-model="formData.endtime"></a-date-picker>
            </a-form-model-item>
			<a-form-model-item label="身份证号码">
                <a-input placeholder="请输入身份证号码" v-model="formData.idcard" ></a-input>
            </a-form-model-item>
			<a-form-model-item label="所属工地">
                <a-select placeholder="所属工地" v-model="formData.workplace" @change="wpchange">
					<a-select-option v-for="item in workplaceArray" :key="item.id" :text="item.name" :value="item.id+''">{{item.name}}</a-select-option>
				</a-select>
            </a-form-model-item>
			<a-form-model-item label="姓名">
                <a-input placeholder="请输入姓名" v-model="formData.name"></a-input>
            </a-form-model-item>
			<a-form-model-item label="银行卡号">
                <a-input placeholder="请输入银行卡号" v-model="formData.banknum"></a-input>
            </a-form-model-item>
			<a-form-model-item label="开户行">
                <a-input placeholder="请输入开户行" v-model="formData.bankname"></a-input>
            </a-form-model-item>
			<a-form-model-item label="用工类别">
                <a-select placeholder="请选择用工类别" v-model="formData.worktype">
						<a-select-option value="1">点工</a-select-option>
                        <a-select-option value="2">带班</a-select-option>
                        <a-select-option value="3">班组</a-select-option>
				</a-select>
            </a-form-model-item>
			<a-form-model-item label="所属班组">
                <a-input placeholder="请输入所属班组" v-model="formData.group"></a-input>
            </a-form-model-item>


			<a-form-model-item label="EXCEL导入">
				<a-upload 
				 name="file"
				 :multiple="false"
				 :showUploadList="false"
				 accept="xlsx,xls"
				 :beforeUpload="filehandle"
				>
					<a-button>上传excle</a-button>
				</a-upload>
            </a-form-model-item>
			<div v-for="(item,id) in formData.datainfo" :key="item.key" class="datainfo">
				<a-form-model-item label="所属工地">
					<a-select placeholder="所属工地" v-model="item.workplace">
						<a-select-option v-for="item in workplaceArray" :key="item.id" :text="item.name" :value="item.id+''">{{item.name}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item   label="薪资信息" >
					<div style="display:flex">
						<a-form-model-item>
							<a-select style="width:100px" placeholder="类型" v-model="item['price']['type']">
									<a-select-option value="1">男大工</a-select-option>
									<a-select-option value="2">男小工</a-select-option>
									<a-select-option value="3">女小工</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item >
							<a-input-number style="width:100px" placeholder="日薪" v-model="item['price']['price']"></a-input-number>
						</a-form-model-item>
						<a-form-model-item >
							<a-input-number placeholder="上班天数" v-model="item['price']['num']"></a-input-number>
						</a-form-model-item>
						<a-form-model-item >
							<a-input-number placeholder="总价" v-model="item['price']['sum']" @focus="item['price']['sum']=item['price']['price']*item['price']['num']"></a-input-number>
						</a-form-model-item>
					</div>
				</a-form-model-item>
				<a-form-model-item label="房屋信息">
					<div style="display:flex">
						<a-form-model-item>
							<a-select style="min-width:100px"  placeholder="类型" v-model="item['room']['type']" allowClear>
								<a-select-option v-for="item in roomtypeArray" :key="item.id" :value="item.id+''">{{item.name}}</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item>
							<a-input-number placeholder="单价" style="width:100px" v-model="item['room']['price']"></a-input-number>
						</a-form-model-item>
						<a-form-model-item>
							<a-input-number placeholder="面积数" v-model="item['room']['num']"></a-input-number>
						</a-form-model-item>
						<a-form-model-item>
							<a-input-number placeholder="总价" v-model="item['room']['sum']" @focus="item['room']['sum']=item['room']['price']*item['room']['num']"></a-input-number>
						</a-form-model-item>
					</div>
				</a-form-model-item>
				<a-form-model-item label="补贴信息">
					<div style="display:flex">
						<a-form-model-item >
							<a-textarea placeholder="补贴说明" style="width:250px" v-model="item['butie']['note']"></a-textarea>
						</a-form-model-item>
						<a-form-model-item >
							<a-input-number style="width:100px" placeholder="补贴金额" v-model="item['butie']['num']"></a-input-number>
						</a-form-model-item>
					</div>
				</a-form-model-item>
				<a-form-model-item label="扣除信息">
					<div style="display:flex;">
						<a-form-model-item>
							<a-textarea style="width:250px" placeholder="扣除说明" v-model="item['kouchu']['note']"></a-textarea>
						</a-form-model-item>
						<a-form-model-item >
							<a-input-number placeholder="扣除金额" style="width:100px" v-model="item['kouchu']['num']"></a-input-number>
						</a-form-model-item>
					</div>
				</a-form-model-item>
				<div style="display:flex;justify-content:center;">
					<a-button @click="addDatainfo()">添加</a-button>
					<a-button v-if="id!=0" @click="delDatainfo(item.key)">删除</a-button>
				</div>
			</div>			

			<!-- 日薪*上班天数+房屋类型面积*单价总和+补贴总和-扣除总和 -->
			<!-- 应付金额=日薪*上班天数+房屋类型面积单价总和+补贴总和-扣除总和 -->
			<a-form-model-item label="应付金额">
                <a-input-number placeholder="请输入应付金额" v-model="formData.yingfu" style="width:200px" @focus="getyingfu"></a-input-number>
            </a-form-model-item>

			<a-form-model-item label="扣除工资预支单金额">
				<a-input-number placeholder="请输入扣除工资预支单金额" style="width:200px" v-model="formData.kouyuzhi" @focus="getkouyuzhi"></a-input-number>
			</a-form-model-item>
			<a-form-model-item label="扣除项目发放金额">
                <a-input-number placeholder="请输入扣除项目发放金额" style="width:200px" v-model="formData.koufafang" @focus="getkoufafang"></a-input-number>
            </a-form-model-item>
			<a-form-model-item label="是否发放">
                <a-select placeholder="请选择发放状态" v-model="formData.shifoufafang">
				<a-select-option value="0">未发放</a-select-option>
				<a-select-option value="1">已发放</a-select-option>
				</a-select>
            </a-form-model-item>
			<a-form-model-item label="结余金额">
                <a-input-number placeholder="请输入结余金额" style="width:200px" v-model="formData.jieyu" @focus="getjieyu"></a-input-number>
            </a-form-model-item>
			</div>
		</template>

		<!-- 其他的操作按钮 -->
       <template v-slot:otherBarOperation>
	       <exprot-excel :tref="$refs.tableref" ></exprot-excel>
       </template>

		<!-- 表格数据转化插槽 -->
		<template v-slot:roomtype="{text}">
			{{roomtypeshow(text)}}
        </template>
		<template v-slot:workplace="{text}">
			{{workplaceshow(text)}}
        </template>
		<template v-slot:worktype="{text}">
			{{worktypeshow(text)}}
        </template>
		<template v-slot:shifoufafang="{text}">
			{{text==1?"已发放":"未发放"}}
        </template>

		<!-- 统计数据 -->
	 	<template v-slot:totalinfo="{tabledata}">
			 <div class="totalinfo">
				<a-tag color="blue" style="text-align:left">
					<span  style="font-size:15px;padding:5px;display:inline-block">
					<strong>全部：</strong>
					应付：{{getSumData(tabledata).yingfu||"0.00"}} 元,
					预支：{{getSumData(tabledata).yuzhi||"0.00"}} 元,
					公司发放：{{getSumData(tabledata).koufafang||"0.00"}} 元,
					结余：{{getSumData(tabledata).jieyu||"0.00"}} 元
					<!-- 天数：{{getSumData(tabledata).workday}} -->
				</span>
				</a-tag>
				<a-tag color="blue" style="text-align:left">
					<span  style="font-size:15px;padding:5px;display:inline-block">
					<strong>本页：</strong>	
					应付：{{getSumData(tabledata).pyingfu}} 元,
					预支：{{getSumData(tabledata).pyuzhi}} 元,
					公司发放：{{getSumData(tabledata).pkoufafang}} 元,
					结余：{{getSumData(tabledata).pjieyu}} 元
					<!-- 天数：{{getSumData(tabledata).pworkday}}  -->
				</span>
				</a-tag>
			</div>
		 </template>


		<!--添加按钮预留位置  -->
		<template v-slot:addAction="{showModal}">
			<a-form-model-item>
				<a-button type="primary" @click="addht(showModal)"> <a-icon type="plus"/> 添加</a-button>
			</a-form-model-item>
		</template>

		<!-- 行末操作按钮插槽 -->
		<template v-slot:tableAction="{record,showModal,showDelConfirm}">
			<div style="display:flex;width:200px">
				<a class="tAction" @click="updateBGhetong(record,showModal)"><a-icon type="edit" />修 改</a>
				<a-divider type="vertical" />
				<a class="tAction" @click="deletBGhetong(record,showDelConfirm)"><a-icon type="delete" /> 删 除</a>
				<a-divider type="vertical" />
				 <downloadexcel
				 	class="exportoperation"
					:fields="excelheader"
					:fetch="getDetialData(record)"
					name="账单.xls"
				>导出账单</downloadexcel>
			</div>
        </template>
		</Table>
	</div>
</template>

<script>
import Baogongzhangdan  from "./index.js"
export default Baogongzhangdan
</script>
<style lang="less" scoped>
.exportoperation{
	color: #1890ff;
	cursor: pointer;
}
.totalinfo{
		margin: 0px 0px 10px 20px;
		display: flex;
		justify-content: flex-start;
	}

.datainfo{
	margin-bottom: 25px;
	.ant-form-item{
		margin-bottom: 2px;
	}
}
</style>
<style>
.bianhong{
	color: red;
}
</style>



